import { handleActions } from 'redux-actions'
import Immutable from 'immutable'

import * as actions from '../actions/qrimages';

const initialState = Immutable.fromJS({
  data: [],
  export: {},
  loading: false,
  loaded: false
})

export default handleActions({
  [actions.getQRImagesSucceeded](state, { payload }) {
    return state.set('loading', false).set('loaded', true)
      .set('data', Immutable.fromJS(payload.data));
  },
  [actions.getQRImagesFailed](state, action) {
    return state.set('loading', false)
      .merge(Immutable.fromJS({ error: action.payload }))
  },
  [actions.checkQRImageSucceeded](state, { payload }) {
    return state.set('loading', false).set('loaded', true)
      .set('data', Immutable.fromJS(payload.data));
  },
  [actions.checkQRImageFailed](state, action) {
    return state.set('loading', false)
      .merge(Immutable.fromJS({ error: action.payload }))
  },
  // 用户积分导出
  [actions.getQRImageExportRequested](state) {
    return state.delete('error').set('loading', true)
  },
  [actions.getQRImageExportSucceeded](state, { payload }) {
    return state.set('loading', false).set('loaded', true).update('export', v => v.merge(Immutable.fromJS(payload)));
  },
  [actions.getQRImageExportFailed](state, action) {
    return state.set('loading', false)
      .merge(Immutable.fromJS({ error: action.payload }))
  }
}, initialState)



// WEBPACK FOOTER //
// ./reducers/qrimages.js